import React from 'react';
import profileImage from '../../styles/img/account/profile-image.png';
const ProfilBox = ({ click, user }) => {

    if (!user || !user._id) {
      return (<></>);
    }

    const hasFirstNameAndLastName = !!user.prenom && !!user.nom;
    const displayName = hasFirstNameAndLastName ? `${user.prenom} ${user.nom}` : user.email;

    return (
      <div className="profil-box ">
        <button className="profil-box-button bg-gradient1" onClick={click}>
          <img className="" src={profileImage} />
          <div className='profil-text'>
            <div className={`profil-box-name ${hasFirstNameAndLastName ? '' : 'email'}`}>
              {displayName}
            </div>
            <div className='profil-box-second-text'>
              Voir le profil
            </div>
          </div>

        </button>
      </div>
    );
  }
  export default ProfilBox;
